// PF1/FLO-54465: on the tester-app host Kong routes only these prefixes to utest-fe
// (deploy/utest-fe/deploy/config.yml, `utest-fe-app` uris) and "/" plus everything else to
// tester-app, so a same-origin URL outside them must be a document load. AngularJS html5Mode would
// otherwise treat it as in-app. Keep this list in sync with config.yml.
const ROOT_PATH = '/';

export const UTEST_APP_PATH_PREFIXES: readonly string[] = [
  '/home',
  '/community',
  '/academy',
  '/courses',
  '/articles',
  '/forums',
  '/profile',
  '/projects',
  '/resources',
  '/tools',
  '/status',
  '/search-result',
  '/leaderboard',
  '/activity',
  '/followers',
  '/following',
  '/liked-content',
  '/referrals',
  '/flagged-content',
  '/url-shortener',
  '/upoints',
  '/hall-of-fame',
  '/emoji',
  '/my-forums',
  '/pending-articles',
  '/new',
  '/update',
  '/transfer',
  '/submit-a-tool',
  '/404',
  '/401',
];

export function isUtestAppPath(pathname: string): boolean {
  return pathname === ROOT_PATH || UTEST_APP_PATH_PREFIXES.some((p) => pathname.startsWith(p));
}

// Returns the deregistration function of the $locationChangeStart handler.
export function installTesterAppLinkGuard($rootScope: any, $window: any): () => void {
  const loadedPath: string = $window.location.pathname;
  return $rootScope.$on('$locationChangeStart', (event: any, newUrl: string) => {
    let url: URL;
    try {
      url = new URL(newUrl);
    } catch {
      return;
    }
    // The document's own URL (initial sync, back to it, query/hash changes) never reloads, so a
    // mistaken hard load cannot loop.
    if (url.origin !== $window.location.origin || url.pathname === loadedPath || isUtestAppPath(url.pathname)) {
      return;
    }
    event.preventDefault();
    $window.location.assign(newUrl);
  });
}
